const formatWeight = weight => weight || '-';

export { formatWeight };
